var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLegal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7986 1.25403C11.9331 1.21478 12.076 1.2148 12.2105 1.25408L21.0226 3.82827C21.3359 3.9198 21.5513 4.20708 21.5513 4.53349V9.81254C21.5513 15.6775 17.7979 20.8842 12.2338 22.7382C12.083 22.7884 11.9201 22.7884 11.7693 22.7382C6.2037 20.8843 2.44922 15.6764 2.44922 9.81009V4.53349C2.44922 4.20701 2.66467 3.91969 2.97809 3.82822L11.7986 1.25403ZM3.91861 5.08442V9.81009C3.91861 14.9618 7.16408 19.5444 12.0015 21.2642C16.8375 19.5444 20.0819 14.9629 20.0819 9.81254V5.08428L12.0044 2.72467L3.91861 5.08442Z",
    fill: "#1C1B1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4173 8.29673C17.7042 8.58365 17.7042 9.04883 17.4173 9.33574L11.5397 15.2133C11.2528 15.5002 10.7876 15.5002 10.5007 15.2133L7.07212 11.7847C6.7852 11.4978 6.7852 11.0326 7.07212 10.7457C7.35904 10.4588 7.82422 10.4588 8.11113 10.7457L11.0202 13.6548L16.3782 8.29673C16.6652 8.00981 17.1303 8.00981 17.4173 8.29673Z",
    fill: "#1C1B1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegal);
export default __webpack_public_path__ + "static/media/legal.afb9ddde8f7eb90f11d82a1a1455b768.svg";
export { ForwardRef as ReactComponent };